// extracted by mini-css-extract-plugin
export default {"container":"rounded-button_container__11fNr","compact":"rounded-button_compact__22IfI","transparent":"rounded-button_transparent__2LGbO"};